export const ipsToWhitelist = [
  '3.73.201.67',
  '3.77.213.42',
  '3.79.127.211',
  '3.120.90.111',
  '18.195.228.240',
  '44.227.14.22',
  '52.28.134.54',
  '52.57.5.72',
  '63.180.186.28',
  '63.180.210.239',
];
